<template>
  <div class="text-h6">アクション</div>
  <div class="row q-mt-sm">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>タイプ</div>
      <div class="text-caption">Type</div>
    </div>
    <q-select
      outlined
      dense
      emit-value
      map-options
      v-model="actionType"
      :rules="[(val) => !isRequired || (val && val.length > 0) || requiredRule.data]"
      :options="typeList"
      :disable="!isAdmin"
      class="col"
    >
      <template v-slot:selected-item="scope">
        <div class="column">
          <div>{{ scope.opt.label }}</div>
          <div class="text-caption">{{ scope.opt.value }}</div>
        </div>
      </template>
    </q-select>
  </div>
  <div class="row q-mt-sm" v-if="actionType !== ''">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>ラベル</div>
      <div class="text-caption">Label</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.label"
      placeholder="Text"
      class="col"
    />
  </div>
  <div class="row q-mt-sm" v-if="isAdmin && (actionType === 'postback' || actionType === 'datetimepicker')">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>データ</div>
      <div class="text-caption">Data</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.data"
      :rules="[(val) => (val && val.length > 0) || requiredRule.data]"
      placeholder="Text"
      class="col"
    />
  </div>
  <div class="row q-mt-sm" v-if="isAdmin && actionType === 'postback'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>表示テキスト</div>
      <div class="text-caption">displayText</div>
    </div>
    <q-input outlined dense v-model="value.displayText" placeholder="Text" class="col" />
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'uri'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>URI</div>
      <div class="text-caption">uri</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.uri"
      :rules="[(val) => (val && val.length > 0) || requiredRule.uri]"
      placeholder="Text"
      class="col"
    />
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'uri' && value.altUri">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>PC用URI</div>
      <div class="text-caption">altUri.desktop</div>
    </div>
    <q-input outlined dense v-model="value.altUri.desktop" placeholder="Text" class="col" />
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'message'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>テキスト</div>
      <div class="text-caption">Text</div>
    </div>
    <q-input
      outlined
      dense
      v-model="value.text"
      :rules="[(val) => (val && val.length > 0) || requiredRule.text]"
      placeholder="Text"
      class="col"
    />
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'datetimepicker'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>日付モード</div>
      <div class="text-caption">Mode</div>
    </div>
    <q-select outlined dense v-model="value.mode" :options="['date', 'time', 'datetime']" class="col" />
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'datetimepicker'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>日付初期値</div>
      <div class="text-caption">Initial</div>
    </div>

    <DateSelectorV2 v-if="value.mode === 'date'" v-model="value.initial" :disable="true" class="col"></DateSelectorV2>
    <q-input
      v-if="value.mode === 'time'"
      outlined
      dense
      v-model="value.initial"
      type="time"
      placeholder="HH:MM"
      class="col"
    />

    <DateTimeSelectorV2
      v-if="value.mode === 'datetime'"
      v-model="value.initial"
      :disable="true"
      class="col"
    ></DateTimeSelectorV2>
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'datetimepicker'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>日付最小値</div>
      <div class="text-caption">Min</div>
    </div>
    <DateSelectorV2
      v-if="value.mode === 'date'"
      v-model="value.min"
      :disable="true"
      class="col"
      :rules="[(val) => minMaxValidate(value.mode, val, value.max) || 'invalid property']"
    ></DateSelectorV2>
    <q-input
      v-if="value.mode === 'time'"
      outlined
      dense
      v-model="value.min"
      :rules="[(val) => minMaxValidate(value.mode, val, value.max) || 'invalid property']"
      type="time"
      placeholder="HH:MM"
      class="col"
    />

    <DateTimeSelectorV2
      v-if="value.mode === 'datetime'"
      v-model="value.min"
      :disable="true"
      :rules="[(val) => minMaxValidate(value.mode, val, value.max) || 'invalid property']"
      class="col"
    ></DateTimeSelectorV2>
  </div>
  <div class="row q-mt-sm" v-if="actionType === 'datetimepicker'">
    <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
      <div>日付最大値</div>
      <div class="text-caption">Max</div>
    </div>
    <DateSelectorV2
      v-if="value.mode === 'date'"
      v-model="value.max"
      :disable="true"
      class="col"
      :rules="[(val) => minMaxValidate(value.mode, value.min, val) || 'invalid property']"
    ></DateSelectorV2>

    <q-input
      v-if="value.mode === 'time'"
      outlined
      dense
      v-model="value.max"
      :rules="[(val) => minMaxValidate(value.mode, value.min, val) || 'invalid property']"
      type="time"
      placeholder="HH:MM"
      class="col"
    />

    <DateTimeSelectorV2
      v-if="value.mode === 'datetime'"
      v-model="value.max"
      :disable="true"
      :rules="[(val) => minMaxValidate(value.mode, value.min, val) || 'invalid property']"
      class="col"
    ></DateTimeSelectorV2>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageDatetimePickerAction,
  IFlexMessageMessageAction,
  IFlexMessagePostbackAction,
  IFlexMessageURIAction,
} from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import DateSelectorV2 from '@/components/common/ui/DateSelectorV2.vue'
import DateTimeSelectorV2 from '@/components/common/ui/DateTimeSelectorV2.vue'

@Options({
  components: { DateSelectorV2, DateTimeSelectorV2 },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Action extends Vue {
  @Prop()
  modelValue!:
    | IFlexMessagePostbackAction
    | IFlexMessageURIAction
    | IFlexMessageMessageAction
    | IFlexMessageDatetimePickerAction

  @Prop()
  isRequired!: boolean

  @Prop()
  isAdmin!: boolean

  postbackAction: IFlexMessagePostbackAction = {
    type: 'postback',
    label: 'action',
    data: 'hello',
  }

  uriAction: IFlexMessageURIAction = {
    type: 'uri',
    label: 'action',
    uri: 'http://linecorp.com/',
    altUri: {
      desktop: '',
    },
  }

  messageAction: IFlexMessageMessageAction = {
    type: 'message',
    label: 'action',
    text: 'hello',
  }

  dateTimePickerAction: IFlexMessageDatetimePickerAction = {
    type: 'datetimepicker',
    label: 'action',
    data: 'hello',
    mode: 'date',
  }

  get value() {
    return this.modelValue
  }

  set value(
    value:
      | IFlexMessagePostbackAction
      | IFlexMessageURIAction
      | IFlexMessageMessageAction
      | IFlexMessageDatetimePickerAction
      | undefined
  ) {
    this.$emit('update:modelValue', value)
  }

  get actionType() {
    return this.modelValue?.type ?? ''
  }

  set actionType(value: string) {
    if (value === 'postback') {
      this.value = cloneDeep(this.postbackAction)
    } else if (value === 'uri') {
      this.value = cloneDeep(this.uriAction)
    } else if (value === 'message') {
      this.value = cloneDeep(this.messageAction)
    } else if (value === 'datetimepicker') {
      this.value = cloneDeep(this.dateTimePickerAction)
    } else {
      this.value = undefined
    }
  }

  get typeList() {
    return [
      {
        label: '',
        value: '',
      },
      {
        label: 'ポストバック',
        value: 'postback',
      },
      {
        label: 'URI',
        value: 'uri',
      },
      {
        label: 'メッセージ',
        value: 'message',
      },
      {
        label: '日時選択',
        value: 'datetimepicker',
      },
    ]
  }

  get requiredRule() {
    return {
      data: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.data'),
      }),
      uri: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.uri'),
      }),
      text: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.common.flex_message.text'),
      }),
    }
  }

  minMaxValidate(mode, min, max) {
    if (!min || !max) return true
    if (mode === 'date') return new Date(min) < new Date(max)
    if (mode === 'time') return this.toMinutes(min) < this.toMinutes(max)
    if (mode === 'datetime') return new Date(min) < new Date(max)
    return false
  }

  toMinutes(timeStr) {
    const [h, m] = timeStr.split(':').map(Number)
    return h * 60 + m
  }

  @Watch('value.mode')
  onChangeMode() {
    if (this.value && 'mode' in this.value) {
      this.value.initial = undefined
      this.value.min = undefined
      this.value.max = undefined
    }
  }

  @Watch('value', { immediate: true, deep: true })
  onValueChanged(val) {
    if (val?.type === 'uri') {
      if (!('altUri' in val)) {
        this.value = {
          ...cloneDeep(this.uriAction),
          ...val,
          altUri: {
            ...cloneDeep(this.uriAction.altUri),
            ...(val.altUri ?? {}),
          },
        }
      } else if (!('desktop' in val.altUri)) {
        this.value = {
          ...val,
          altUri: {
            desktop: '',
          },
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
